// extracted by mini-css-extract-plugin
module.exports = {"shortBox":"ShortBox_shortBox__rUlgo","title":"ShortBox_title___OUgB","container":"ShortBox_container__GeAda"};